import { AfterViewInit, Component, Input } from '@angular/core';
import {
	AuthnService,
	ComponentBase,
	DeploymentContext,
	Summary,
} from '@Common';
import { TagWithCount } from 'company-finder-common';
import Swiper from 'swiper';

@Component({
	selector: 'company-overview',
	templateUrl: './company-overview.component.html',
	styleUrls: ['./company-overview.component.scss'],
	standalone: false,
})
export class CompanyOverviewComponent
	extends ComponentBase
	implements AfterViewInit
{
	@Input()
	public summary: Summary;
	@Input()
	public tagCounts: TagWithCount[];

	public constructor(
		dc: DeploymentContext,
		private _authnService: AuthnService
	) {
		super(dc);
	}

	ngAfterViewInit(): void {
		const swiper = document.querySelector('.middle-swiper') as {
			swiper?: Swiper;
		};
		// The DOM may have changed (specifically removing tiles)
		// This could cause issues, especially around pagination,
		// so get the swiper to update.
		swiper?.swiper?.update();
	}

	public get isInternal(): boolean {
		return this._authnService.isInternal;
	}

	public get showDeals(): boolean {
		return (
			this.isInternal &&
			this.featureSwitches.enableSectors &&
			this.featureSwitches.enableDealsWidget
		);
	}

	public get showNewCompanies(): boolean {
		return (
			this.featureSwitches.enableShowNewCompanies &&
			(this._authnService.isExternalUser ||
				(!this._deploymentContext.featureSwitches.enablePaywall &&
					!this._authnService.isAuthenticatedUser))
		);
	}
}
